export default "__VITE_ASSET__dfb8fae5__"